import { createTheme } from '@mui/material/styles';
import { mainRed } from './colors'

export const theme = createTheme({
    palette: {
      primary: {
        main: mainRed
      }
    }
  });